export default function About() {
  return (
    <section className="w-full py-16 md:py-24 px-6 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16">
          <div className="flex-1">
            <div className="w-full aspect-[4/3] rounded-[40px] overflow-hidden bg-background-100 relative">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20composition%20with%20overlapping%20translucent%20shapes%20in%20warm%20earth%20tones%2C%20minimalist%20design%20with%20subtle%20gradients%2C%20soft%20diffused%20lighting%2C%20clean%20modern%20aesthetic%2C%20architectural%20precision%2C%20monochrome%20treatment%20with%20warm%20beige%20and%20charcoal%20tones%2C%20sophisticated%20texture%2C%20balanced%20asymmetry%2C%20no%20text%20no%20people&width=800&height=600&seq=about-geometric-composition&orientation=squarish"
                alt="Abstract geometric composition representing clean architecture and engineering precision"
                title="Clean architecture and engineering precision abstract visualization"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <div className="inline-flex self-start px-4 py-1.5 rounded-full bg-accent-100/80 mb-6">
              <span className="font-label text-xs font-medium text-accent-900 tracking-wide uppercase">
                About the team
              </span>
            </div>
            <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.12] tracking-tight">
              Clean architecture,
              <br />
              lasting results
            </h3>
            <p className="mt-6 font-body text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
              We follow modern software engineering practices including clean architecture,
              performance optimization, and user-centered design. Every system we build is
              crafted with maintainability and scalability as core priorities, ensuring our
              solutions remain robust and adaptable as technology evolves.
            </p>
            <p className="mt-4 font-body text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
              Our team emphasizes continuous innovation, improvement of development
              workflows, and adoption of up-to-date engineering standards to deliver
              reliable and future-ready IT solutions. We actively explore new technologies
              and evolve internal processes to maintain high technical excellence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}